<template>
	<div class="col-12 pl-0 pr-0">
		<div class="col-12 pl-0 pr-0" v-if="step == 2">
			<div class="col-12 pl-md-4 pr-md-4 pt-2 pb-2 bg-light-blue mt-3 color-white cus-box-shadow rounded-cus font-size-10 d-flex">
				<i class="fas fa-box-open mt-auto mb-auto"></i>
				<div class="pl-2">Silahkan pilih metode pembayaran Anda agar pembayaran anda dapat diproses</div>
			</div>
			<div class="col-12 pl-md-4 pr-md-4 pt-3 pt-md-4 pb-3 mt-3 bg-white cus-box-shadow rounded-cus d-flex flex-wrap">
				<div class="col-lg-12 pl-0 pr-0">
					<div class="col-12 pl-0 pr-0 d-flex font-size-10">
						<div class="col-6 pl-0 pr-0 pl-md-3 mt-auto mb-auto font-size-sm-9">Metode Pembayaran</div>
						<div class="col-6 pl-2 pr-0">
							<v-select label="text" class="font-size-10 font-size-sm-9 pt-1 pb-1" :options="payment" v-model="paymentMethod" return-object @input="resetPaymentValue">
							</v-select>

							<!-- {{ paymentMethod }} -->
						</div>
					</div>
					<div class="col-12 pl-0 pr-0 font-size-10 mt-3 border-top" v-if="paymentMethod.value == 1">
						<div class="col-12" v-for="(bank, index) in dataBankAccount" :key="index" v-bind:class="{'mt-3': index == 0}">
							<label class="product-name transfer color-black mb-0 pl-0">
								<div class="background-white z-index-1 pb-2 pb-md-0 pt-1">
									<h2 class="mb-0 d-flex">
										<input type="radio" name="radio" v-model="paymentValue" v-bind:value="bank.bank_account_bank" @change="setPaymentMethodValue">
										<div class="col-3 offset-1"><img class="width-90 img-fluid pt-3 pt-md-0" :src="'assets/bank/'+bank.bank_account_bank.toLowerCase()+'.svg'" alt=""></div>
										<div class="col-9 font-size-10 color-black font-size-sm-10 m-auto">
											<div><span class="f-lato">{{ bank.bank_account_no }}</span> a/n {{bank.bank_account_name}}</div>
										</div>
									</h2>
								</div>
							</label>
						</div>
					</div>
					<div class="col-12 pl-0 pr-0 font-size-10 mt-3 border-top" v-if="paymentMethod.value == 2">
						<div class="col-12" v-for="(va, index) in Virtual_Account" :key="index" v-bind:class="{'mt-3': index == 0}">
							<label class="product-name transfer color-black mb-0 pl-0">
								<div class="background-white z-index-1 pb-2 pb-md-0 pt-1">
									<h2 class="mb-0 d-flex">
										<input type="radio" name="radio" v-model="paymentValue" v-bind:value="va.payment_value" @change="setPaymentMethodValue">
										<div class="col-3 offset-1"><img class="width-90 img-fluid pt-3 pt-md-0" :src="'assets/bank/'+va.payment_value.toLowerCase()+'.svg'" alt=""></div>
										<div class="col-9 font-size-10 color-black font-size-sm-10 m-auto">
											<div>{{ va.name }}</div>
										</div>
									</h2>
								</div>
							</label>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import vSelect from "vue-select";
import { mapState, mapActions, mapMutations} from 'vuex';

export default {
	components: {
		vSelect
	},
	data() {
		return {
			success: true,
			bank: [],
			payment: [
				{
					text: "Transfer Bank",
					value: 1
				},
				{
					text: "Virtual Account",
					value: 2
				}
				// {
				// 	text: "Tunai",
				// 	value: 3
				// }
			// }, {
			// 	text: "Kartu Kredit",
			// 	value: 4
		],
		Virtual_Account: [
			{
				name: "Virtual Account BCA",
				img : "assets/bank/bca.svg",
				payment_value : 'bca',
				tutorial:[
					{
						"via":"ATM BCA",
						"tutorial":[
							"Kunjungi ATM Terdekat dan masukkan PIN Anda","Pada menu utama, pilih menu <b> Transaksi Lainnya </b>","Pilih menu <b>Transfer</b> dan kemudian pilih <b>BCA Virtual Account</b>", "Masukkan no. BCA Virtual Account Anda  & klik <b>Lanjutkan</b>", "Periksa kembali rincian pembayaran Anda, lalu pilih Ya", "Transaksi Anda berhasil"
						]    
					},
					{
						"via":"Klik BCA",
						"tutorial":[
							"Login pada aplikasi KlikBCA, masukkan user ID & PIN.", "Pilih <b>Transfer Dana</b>, kemudian pilih <b>Transfer ke BCA Virtual Account</b>.", "Masukkan no. BCA Virtual Account Anda  & klik <b>Lanjutkan</b>.", "Periksa rincian pembayaran Anda & klik <b>Lanjut</b>", "Pastikan data yang dimasukkan sudah benar, dan Input <b>Respon KeyBCA</b>, lalu klik <b>Kirim</b>", "Transaksi Berhasil."
						]
					},
					{
						"via":"Mobile BCA",
						"tutorial":[
							"Login pada aplikasi M-BCA, masukkan PIN M-BCA.","Pilih <b>m-Transfer</b>, pilih <b>BCA Virtual Account</b>.","Klik <b>Input no. Virtual Account</b>, lalu masukkan no BCA Virtual Account Anda", "Klik <b>OK</b> & <b>Send</b>.", "Periksa rincian pembayaran Anda kemudian pilih <b>OK<b> kemudian masukkan PIN M-BCA Anda.", "Periksa kembali data transaksi Anda, kemudian klik <b>OK</b>", "Transaksi Anda berhasil"
						]
					}
				]
			},
		],
		month: [{
			text: "01",
			value: 1
		}, {
			text: "02",
			value: 2
		}],
		year: [{
			text: "2020",
			value: 0
		}, {
			text: "2021",
			value: 1
		}],
		selected: '',
		paymentMethod: '',
		paymentValue: '',
	}
},
props: {
	registrationData: {
		type: Object
	},
},
computed: {
	...mapState('po_cart', ['cart', 'dataSerial', 'selectedPayment', 'step', 'paymentProgress']),
	...mapState('po', ['dataBankAccount']),

	price_total(){
		let price_total = 0
		if(this.cart){
			this.cart.forEach(el => {
				price_total += parseInt(el.product_price) * parseInt(el.quantity)
			});
		}
		return price_total;
	},
},
methods:{
	...mapMutations('po_cart', ['setPayment', 'setPaymentValue', 'setPayTotal', 'paymentProgressAct']),
	...mapActions('po', ['getBankAccount']),

	setPaymentMethodValue(){
		//console.log(this.paymentMethod)
		//console.log(this.paymentValue)
		this.paymentProgressAct(true)
	},
	resetPaymentValue(){
		this.paymentValue = ''
		this.paymentProgressAct(false)
	}
},
watch: {
	paymentMethod(){
		this.setPayment(this.paymentMethod)
	},
	paymentValue(){
		this.setPaymentValue(this.paymentValue)
	}
},
created(){
	this.getBankAccount()
},
mounted(){
}
};
</script>
